import {
  browserLocalPersistence,
  isSignInWithEmailLink,
  onAuthStateChanged,
  setPersistence,
  signInWithEmailLink,
} from "firebase/auth";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { firebaseAuth } from "../../api/firebase/firestoreService";
import { LoaderMessage } from "../../components/loaderMessage/loaderMessage";
import { ScreenNamesForBigQuery } from "../../enums/eventsData";
import { EventsName } from "../../enums/eventsName";
import { loginSuccess } from "../../redux/slice/auth-slice";
import { AppDispatch } from "../../redux/store/store";
import { apiWorkerManager } from "../../workerManagers/workerManager";

const FinalSignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  // ✅ Handle sign-in with magic link
  useEffect(() => {
    const completeSignIn = async () => {
      if (typeof window === "undefined") return;

      if (isSignInWithEmailLink(firebaseAuth, window.location.href)) {
        let email = window.localStorage.getItem("emailForSignIn");

        if (!email) {
          // If the user opens link on another device
          email =
            window.prompt("Please provide your email for confirmation") || null;
        }

        if (!email) {
          console.error("Email is required for sign-in.");
          navigate("/auth");
          return;
        }

        try {
          // ✅ Ensure persistence is set BEFORE sign-in
          await setPersistence(firebaseAuth, browserLocalPersistence);

          const result = await signInWithEmailLink(
            firebaseAuth,
            email,
            window.location.href,
          );

          window.localStorage.removeItem("emailForSignIn");

          console.log("User signed in:", result.user);

          // Store in Redux
          dispatch(
            loginSuccess({
              email: result.user.email,
              id: result.user.uid,
            }),
          );

          navigate("/"); // ✅ Navigate after successful login
          apiWorkerManager.enqueueAndProcess({
            event_name: EventsName.LOGIN,
            patient_id: "",
            user_id: result.user.uid,
            user_email: result.user.email || "",
            order_id: "",
            org_id: "",
            additional_data: {
              screen_name: ScreenNamesForBigQuery.WORKLIST,
              user_id: result.user.uid,
            },
          });
        } catch (error) {
          console.error("Error signing in with email link:", error);
          navigate("/auth");
        }
      } else {
        console.log("Not a sign-in email link, redirecting to auth");
        navigate("/auth");
      }
    };

    completeSignIn();
  }, [dispatch, navigate]);

  // ✅ Keep listening for auth state even on refresh
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
      if (user) {
        dispatch(
          loginSuccess({
            email: user.email,
            id: user.uid,
          }),
        );
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  return (
    <div className="final-sign-in--container flex h-full items-center justify-center">
      <LoaderMessage message={"Signing in..."} />
    </div>
  );
};

export default FinalSignIn;
